import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

i18next
  .use(initReactI18next)
  .init({
    resources: require(`./locales/en-US/translations`).translations,
    initImmediate: false,
    lng: 'en-US',
    fallbackLng: 'en-US'
  });

export default i18next;
